import React from 'react';
import { ThemeProps } from '@theme/base';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { Grid } from '@mui/material';
import { mq } from '@styles/breakpoints';
import { ImagesResponse, Testimonial } from '@model/iceberg';
import { TestimonialsContainer } from '@components/common/testimonials';
import { BaseHero, ImageContainer } from '@components/common/hero/base/BaseHero';
import { TestId } from '@components/test-ids';
import { BottomContainer } from '../bottom/BottomContainer';

export interface TestimonialHeroProps {
  image: ImagesResponse;
  testimonials?: Array<Testimonial>;
}

const GridContainer: any = styled(Grid)(({ theme }: ThemeProps) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  width: '100%',
  maxWidth: theme.custom.contentSizes.maxContentWidth,
  flex: 1,
  margin: '0 auto',
  height: '100%',
  overflow: 'hidden',
  [mq.small]: {
    alignItems: 'center'
  }
}));

const StyledHero = styled(BaseHero)({
  [ImageContainer as any]: {
    height: '100%',
    position: 'absolute'
  }
});

export const TestimonialHeroComponent = ({ image, testimonials }: TestimonialHeroProps) => {
  return (
    <StyledHero
      testId={TestId.testimonialHero}
      src={image.images[0]}
      renderBottom={image.destination.name ? <BottomContainer destination={image.destination} /> : null}
      renderMain={
        <GridContainer container={true}>
          <Grid item={true} xs={'auto'} sm={1} style={{ padding: 0 }} />
          <Grid item={true} xs={12} sm={6} lg={6} xl={6}>
            <TestimonialsContainer timeout={15000} testimonials={testimonials} />
          </Grid>
        </GridContainer>
      }
    />
  );
};

export const TestimonialHero = withTheme(TestimonialHeroComponent);
